<template>
    <header class="header layout justify-space-between">
        <Logo :url="require('../../../../public/images/' + logo)" :classes_added="'header__logo'" />
        <NavMenu v-if="menuVisible" />
    </header>
</template>

<script>
import Logo from '@/components/ui/logo/logo.vue';
import NavMenu from '@/components/blocks/nav/nav.vue';
import {mapGetters} from 'vuex';
import REGION_CODES from '@/configs/region_codes';


export default {
  name      : 'HeaderMenu',
  components: {
    Logo,
    NavMenu,
  },
  props: {
    classes_added: {
      type: String,
    },
    nav_item: {
      type: String,
    },
    menuVisible: {
      type   : Boolean,
      default: true,
    },
  },
  computed: {
    ...mapGetters('profile/general', ['lang']),
    ...mapGetters('profile/user', [
      'user',
    ]),
    logo() {
      return this.user.region_code === REGION_CODES.BITUM_MATERIALS ? 'lukoil-logo.svg' : this.lang == 'ru' ? 'lukoil-logo.png' : 'lukoil-logo-en.svg';
    },
  },
  methods: {
    goto(item) {
      this.$router.push({name: item.route});
    },
  },
};
</script>
